export default __webpack_public_path__ + "static/media/conteudo_extra_16_28.766c257f.jpg";